export const firstScreenInit = () => {
	const inputsGroup = Array.from(
		document.querySelectorAll( '.checkbox-firstscreen' ),
	);

	inputsGroup.forEach( ( element ) => {
		element.addEventListener( 'click', ( event ) => {
			const target = event.target;
			const allInputs = Array.from( target.parentNode.querySelectorAll( 'input' ) );
			if ( element.hasAttribute( 'checked' ) ) {
				allInputs.forEach( ( input ) => {
					input.removeAttribute( 'checked' );
				} );
			} else {
				allInputs.forEach( ( input ) => {
					input.setAttribute( 'checked', true );
				} );
			}
		} );
	} );
};
